// Learn TypeScript:
//  - https://docs.cocos.com/creator/manual/en/scripting/typescript.html
// Learn Attribute:
//  - https://docs.cocos.com/creator/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - https://docs.cocos.com/creator/manual/en/scripting/life-cycle-callbacks.html

import O1HD from "../../engines/gameEngine";
import utilsModel from "../../engines/libs/utilsModel";

const {ccclass, property} = cc._decorator;

@ccclass
export default class NewEggTipPage extends cc.Component {

    
    @property({type:cc.Node,displayName:"提示显示"})
    private TipNode:cc.Node=null;
    static wasGetTip:boolean=false;
 
 
    onLoad()
    {
        this.TipNode.active=NewEggTipPage.wasGetTip;
    }
 
    OnBtnGet()
    {
        utilsModel.loadAndShowVideoAdTrans(()=>{
            NewEggTipPage.wasGetTip=true;
            this.TipNode.active=NewEggTipPage.wasGetTip;
        },()=>{

        },null)
    }

    OnBtnRefuse()
    {
        this.node.destroy();
    }

    // update (dt) {}
}
